export async function generateKey() {
    return await crypto.subtle.generateKey(
      {
        name: "AES-GCM",
        length: 256,
      },
      true,
      ["encrypt", "decrypt"]
    );
  }
  
  export async function encryptPassword(password: string) {
    const key = await generateKey();
    const iv = crypto.getRandomValues(new Uint8Array(12));
  
    const encoder = new TextEncoder();
    const passwordBuffer = encoder.encode(password);
  
    const encryptedPassword = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv: iv },
      key,
      passwordBuffer
    );
  
    localStorage.setItem(
  "encryptedPassword",
  uint8ToBase64(new Uint8Array(encryptedPassword))
);

localStorage.setItem("iv", uint8ToBase64(iv));

    localStorage.setItem(
      "authToken",
      JSON.stringify(await crypto.subtle.exportKey("jwk", key))
    );
  
    return key;
  }
  
  export async function decryptPassword(
    encryptedPassword: string,
    iv: string,
    key: CryptoKey
  ) {
    const encryptedArray = new Uint8Array(
      atob(encryptedPassword)
        .split("")
        .map((char) => char.charCodeAt(0))
    );
    const ivArray = new Uint8Array(
      atob(iv)
        .split("")
        .map((char) => char.charCodeAt(0))
    );
  
    const decryptedPassword = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: ivArray },
      key,
      encryptedArray
    );
  
    const decoder = new TextDecoder();
    return decoder.decode(decryptedPassword);
  }
  
function uint8ToBase64(uint8: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < uint8.length; i++) {
    binary += String.fromCharCode(uint8[i]);
  }
  return btoa(binary);
}
